import axiosInstance from './axiosInstance';

const getDevolutionById = (devolutionId) =>
  axiosInstance.get(`/internal/admin/refunds/${devolutionId}`);

export default getDevolutionById;
